export function createStroke(point, color, lineWidth, rng = Math.random) {
    return {
        points: [point],
        style: {
            color,
            lineWidth,
            opacity: rng() * 0.2 + 0.5,
            offsetX: (rng() - 0.5) * 4,
            offsetY: (rng() - 0.5) * 0.5,
        },
    };
}
export class State {
    constructor() {
        this.drawing = false;
        this.panning = false;
        this.strokes = [];
        this.activeStroke = null;
        this.camera = { zoom: 1, panX: 0, panY: 0 };
    }
    init() {
        this.drawing = false;
        this.panning = false;
        this.strokes = [];
        this.activeStroke = null;
        this.camera = { zoom: 1, panX: 0, panY: 0 };
    }
    getDrawing() {
        return this.drawing;
    }
    setDrawing(value) {
        this.drawing = value;
    }
    getPanning() {
        return this.panning;
    }
    setPanning(value) {
        this.panning = value;
    }
    getStrokes() {
        return this.strokes;
    }
    setStrokes(value) {
        this.strokes = value;
    }
    getActiveStroke() {
        return this.activeStroke;
    }
    setActiveStroke(value) {
        this.activeStroke = value;
    }
    getCamera() {
        return this.camera;
    }
    setCamera(value) {
        this.camera = value;
    }
}
const stateInstance = new State();
export default stateInstance;
